import { TStatuses } from '@/domain/Activities.domain';
import { parse } from 'date-fns';
import { DAILY_DATE_FORMAT, SERVER_FORMAT_DATE } from '../constants/dates';

export const validateDailyStatuses = (statuses: TStatuses, selectedDate: string) => {
    if (statuses.daily?.length) {
        const date = selectedDate
            ? parse(selectedDate, SERVER_FORMAT_DATE, new Date())
            : new Date();

        return statuses.daily
            .filter(({ date_from, date_to }) => {
                const from = parse(date_from, DAILY_DATE_FORMAT, new Date());
                const to = parse(date_to, DAILY_DATE_FORMAT, new Date());

                return date >= from && date <= to;
            })
            .map(({ text }) => text)
            .join('<br/>');
    }

    return undefined;
};

export const createCommonStatusesMarkup = (statuses: TStatuses) => {
    return [
        ...(statuses?.general?.length ? statuses.general : []),
        ...(statuses?.calendar?.length ? statuses.calendar : []),
    ].join('<br/>');
};
